import { render } from "./TPCommonButton.vue?vue&type=template&id=572b00c4&scoped=true&ts=true"
import script from "./TPCommonButton.vue?vue&type=script&lang=ts"
export * from "./TPCommonButton.vue?vue&type=script&lang=ts"

import "./TPCommonButton.vue?vue&type=style&index=0&id=572b00c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-572b00c4"]])

export default __exports__